import { render, staticRenderFns } from "./HomeSectionSchema.vue?vue&type=template&id=20752052&scoped=true"
import script from "./HomeSectionSchema.vue?vue&type=script&lang=js"
export * from "./HomeSectionSchema.vue?vue&type=script&lang=js"
import style0 from "./HomeSectionSchema.vue?vue&type=style&index=0&id=20752052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20752052",
  null
  
)

export default component.exports